export default {
  description:
    'Carica i documenti necessari per verificare la tua attività. I documenti obbligatori sono contrassegnati; puoi aggiungere quelli facoltativi ora o più tardi.',
  missing_one:
    'Manca ancora un documento obbligatorio. Puoi continuare: questo passaggio resterà aperto finché non viene caricato.',
  missing_other:
    'Mancano ancora {{count}} documenti obbligatori. Puoi continuare: questo passaggio resterà aperto finché non vengono caricati.',
  buttons: {
    back: 'Indietro',
    next: 'Avanti',
    finish_later: 'Termina più tardi',
  },
};
